import { render, staticRenderFns } from "./SettingCRM.vue?vue&type=template&id=30824f92"
import script from "./SettingCRM.vue?vue&type=script&lang=js"
export * from "./SettingCRM.vue?vue&type=script&lang=js"
import style0 from "./SettingCRM.vue?vue&type=style&index=0&id=30824f92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports